import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ConfirmAccountComponent } from "./confirm-account/confirm-account.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { IndexComponent } from "./index.component";
import { LoginComponent } from "./login/login.component";
import { LogoutComponent } from "./logout/logout.component";
import { MultifactorAuthComponent } from "./multifactor-auth/multifactor-auth.component";
import { RegisterComponent } from "./register/register.component";
import { ResetComponent } from "./reset/reset.component";

const routes: Routes = [
  {
    path: "",
    component: IndexComponent,
    children: [
      {
        path: "",
        redirectTo: "login",
        pathMatch: "full",
      },
      {
        path: "signup",
        component: RegisterComponent,
      },
      {
        path: "login",
        component: LoginComponent,
      },
      {
        path: "forgot",
        component: ForgotPasswordComponent,
      },
      {
        path: "users/reset-password",
        component: ResetComponent,
      },
      {
        path: "users/confirm",
        component: ConfirmAccountComponent,
      },
      {
        path: "logout",
        component: LogoutComponent,
      },
      {
        path: "multifactor-auth",
        component: MultifactorAuthComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IndexRoutingModule {}
